export default {"src":"/_next/static/media/person.037ecbb7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};